import { IconArrowRightBold, NormalButton, Text, TextButton } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { RecommendOptionValueModel, UserAccountModel } from '../utils/types';

interface SimilarSizeViewProps {
  userAccount: UserAccountModel;
  isPurchaseType: boolean;
  recommendSizeText: string;
  displayedOptions: RecommendOptionValueModel[];
  isReviewButtonVisible?: boolean;
  onReviewClick: () => void;
  onUserFigureClick: () => void;
}

export const SimilarSizeView = ({
  userAccount,
  isPurchaseType,
  recommendSizeText,
  displayedOptions,
  isReviewButtonVisible = false,
  onReviewClick,
  onUserFigureClick,
}: SimilarSizeViewProps) => {
  return (
    <Wrapper>
      <Header>
        <Title variant='Body_18_SemiBold' color='textStrong'>
          {userAccount.name}님의 체형은
        </Title>
        <Subtitle variant='Body_18_SemiBold'>
          <RecommendText as='span' variant='Body_18_SemiBold' color='subSkyBluePrimary'>
            {recommendSizeText}
          </RecommendText>
          <Suffix>{isPurchaseType ? ' 사이즈를 많이 구매했어요' : ' 사이즈를 추천해요'}</Suffix>
        </Subtitle>
      </Header>

      <UserFigureButton onClick={onUserFigureClick}>
        <UserFigureLabel variant='Body_13_Multiline_Medium' color='textTertiary'>
          내 정보
        </UserFigureLabel>
        <UesrFigureDivider />
        <UserFigureValue variant='Body_13_Multiline_Medium' color='textTertiary'>
          {userAccount.body?.sizeText}
        </UserFigureValue>
        <IconArrowRightBold size={16} color='iconQuaternary' />
      </UserFigureButton>

      <ListWrapper>
        {displayedOptions.map((option) => (
          <ListItem key={`${option.ranking}-${option.name}`}>
            <OptionInfo>
              <OptionName variant='Body_13_Multiline_Medium' color='textStrong'>
                {option.name}
              </OptionName>
              <PurchasePercent variant='Body_13_Multiline_Medium' color='textStrong'>
                {option.purchasePercent}% 구매
              </PurchasePercent>
            </OptionInfo>
            <ProgressBarContainer>
              <ProgressBar width={option.purchasePercent || 0} />
            </ProgressBarContainer>
          </ListItem>
        ))}
      </ListWrapper>

      {isReviewButtonVisible && (
        <ButtonWrapper>
          <NormalButton size='small' onClick={onReviewClick} fullWidth variant='tertiaryGray'>
            내 체형 리뷰 보기
            <IconArrowRightBold size={16} color='gray900' />
          </NormalButton>
        </ButtonWrapper>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 24px 16px;
  background-color: ${vars.color.backgroundSurface};
`;

const Header = styled.div`
  margin-bottom: 4px;
`;

const Title = styled(Text)`
  margin-bottom: 2px;
`;

const Subtitle = styled(Text)`
  display: flex;
  align-items: center;
  overflow: hidden;
  gap: 4px;
`;

const RecommendText = styled(Text)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Suffix = styled.span`
  white-space: nowrap;
  flex-shrink: 0;
`;

const UserFigureButton = styled(TextButton)`
  display: flex;
  margin-bottom: 16px;
`;

const UesrFigureDivider = styled.div`
  width: 1px;
  height: 14px;
  margin: 0 4px;
  background: ${vars.color.dividerThin};
`;
const UserFigureLabel = styled(Text)``;

const UserFigureValue = styled(Text)`
  margin-right: 2px;
`;

const ListWrapper = styled.ul`
  padding: 16px 16px 20px 16px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  border-radius: 6px;
  background-color: ${vars.color.backgroundOnElevated};
`;

const ListItem = styled.li`
  width: 100%;
`;

const OptionInfo = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
`;

const OptionName = styled(Text)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 70%;
`;

const PurchasePercent = styled(Text)``;

const ProgressBarContainer = styled.div`
  width: 100%;
  height: 4px;
  background-color: ${vars.color.fillSecondary};
  border-radius: 4px;
  overflow: hidden;
`;

const ProgressBar = styled.div<{ width: number }>`
  height: 100%;
  width: ${({ width }) => width}%;
  background-color: ${vars.color.subSkyBluePrimary};
  border-radius: 4px;
`;

const ButtonWrapper = styled.div`
  margin-top: 12px;
`;
